module.exports = __webpack_public_path__ + "img/wifi-router.d65704d.png";